<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <div class="toolbar-filter-bar">
                <el-form :inline="true" :model="filters" class="toolbar-filter-form" size="small">
                    <div class="toolbar-filter-fields">
                        <el-form-item label="楼栋">
                            <el-select v-model="filters.buildingId" clearable filterable placeholder="全部楼栋"
                                class="toolbar-field-w-md" @change="onBuildingChange">
                                <el-option v-for="b in buildingOptions" :key="b.Id" :label="b.Name" :value="b.Id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="房间">
                            <el-input v-model="filters.roomCode" clearable placeholder="房间号"
                                class="toolbar-field-w-sm"></el-input>
                        </el-form-item>
                        <el-form-item label="检查人">
                            <el-input v-model="filters.inspectorName" clearable placeholder="检查人"
                                class="toolbar-field-w-sm"></el-input>
                        </el-form-item>
                        <el-form-item label="日期">
                            <el-date-picker v-model="filters.dateRange" type="daterange" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" start-placeholder="开始" end-placeholder="结束"
                                class="toolbar-field-w-daterange" :clearable="false"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
                            <el-button type="warning" icon="el-icon-download" :loading="exporting"
                                @click="exportExcel">导出</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>

            <div class="tbl-scroll-host">
                <el-table :data="records" v-loading="listLoading" height="100%" style="width: 100%;" size="small">
                    <el-table-column label="楼栋/房间" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.BuildingName }} {{ scope.row.RoomCode }}
                        </template>
                    </el-table-column>
                    <el-table-column label="归属班级" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ formatClasses(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="SelectedItemsSummary" label="摘要" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column label="类型" width="88" align="center">
                        <template slot-scope="scope">
                            <div v-if="recordChangeTypes(scope.row).length" class="type-tags">
                                <el-tag v-for="t in recordChangeTypes(scope.row)" :key="t"
                                    :type="t === 'Addition' ? 'success' : 'danger'" size="mini" effect="plain">
                                    {{ t === 'Addition' ? '加分' : '扣分' }}
                                </el-tag>
                            </div>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="TotalScore" label="明细净分" min-width="90" align="center">
                        <template slot-scope="scope">
                            <span :class="scoreClass(scope.row.TotalScore)">{{ formatDecimal(scope.row.TotalScore) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="同步值周" min-width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.SyncedToDuty ? 'success' : 'info'" size="mini">
                                {{ scope.row.SyncedToDuty ? '已同步' : '未同步' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="InspectorName" label="检查人" min-width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="InspectDate" label="检查日期" min-width="110" align="center">
                        <template slot-scope="scope">
                            {{ formatDate(scope.row.InspectDate) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="CreateTime" label="提交时间" min-width="160" align="center"></el-table-column>
                    <el-table-column label="操作" width="200" align="center">
                        <template slot-scope="scope">
                            <div class="table-op-pair">
                                <el-button type="text" size="small" class="table-op-link" @click="openDetail(scope.row)">明细</el-button>
                                <el-button v-if="canDelete(scope.row)" type="text" size="small" class="table-op-link table-op-link--danger"
                                    @click="handleDelete(scope.row)">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div style="text-align: right; margin-top: 12px;">
                <el-pagination layout="total, prev, pager, next, jumper" :current-page="page" :page-size="pageSize"
                    :total="total" @current-change="loadRecords" @size-change="handleSizeChange"></el-pagination>
            </div>

            <el-dialog title="宿舍检查明细" :visible.sync="detailVisible" width="760px" :close-on-click-modal="false">
                <div v-if="detailLoading" style="text-align:center;padding:20px;">加载中...</div>
                <div v-else-if="detail">
                    <div class="record-info">
                        <p class="muted">
                            房间：<strong>{{ detail.BuildingName }} {{ detail.RoomCode }}</strong>
                            &nbsp;&nbsp;检查人：<strong>{{ detail.InspectorName }}</strong>
                            &nbsp;&nbsp;日期：<strong>{{ formatDate(detail.InspectDate) }}</strong>
                            &nbsp;&nbsp;明细净分：
                            <span :class="scoreClass(detail.TotalScore)">{{ formatDecimal(detail.TotalScore) }}</span>
                        </p>
                        <p class="muted">班级：<strong>{{ formatClasses(detail) }}</strong></p>
                        <p class="summary">摘要：{{ detail.SelectedItemsSummary || '—' }}</p>
                        <p v-if="detail.Remark" class="muted">备注：{{ detail.Remark }}</p>
                    </div>
                    <el-table :data="detail.Items || []" border style="width:100%;margin-top:10px;">
                        <el-table-column prop="ItemName" label="检查项" min-width="120"></el-table-column>
                        <el-table-column label="类型" width="72" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.ChangeType"
                                    :type="scope.row.ChangeType === 'Addition' ? 'success' : 'danger'" size="small">
                                    {{ scope.row.ChangeType === 'Addition' ? '加分' : '扣分' }}
                                </el-tag>
                                <span v-else>—</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Quantity" label="数量" width="70" align="center"></el-table-column>
                        <el-table-column prop="UnitScore" label="单项分" width="90" align="center">
                            <template slot-scope="scope">
                                <span :class="scoreClass(scope.row.UnitScore, scope.row.ChangeType)">{{ formatDecimal(scope.row.UnitScore) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Score" label="得分" width="90" align="center">
                            <template slot-scope="scope">
                                <span :class="scoreClass(scope.row.Score, scope.row.ChangeType)">{{ formatDecimal(scope.row.Score) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="关联值周" min-width="120" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ formatDutyItemName(scope.row) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
                    </el-table>
                    <div v-if="detail.DutyLinks && detail.DutyLinks.length" style="margin-top:14px;">
                        <div class="section-title">同步值周记录</div>
                        <el-table :data="detail.DutyLinks" border size="small" style="width:100%;">
                            <el-table-column prop="DepartmentName" label="班级" min-width="120" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="DutyInspectCategoryName" label="值周二级类" min-width="120" show-overflow-tooltip></el-table-column>
                            <el-table-column label="类型" width="72" align="center">
                                <template slot-scope="scope">
                                    <div v-if="linkChangeTypes(scope.row).length" class="type-tags">
                                        <el-tag v-for="t in linkChangeTypes(scope.row)" :key="t"
                                            :type="t === 'Addition' ? 'success' : 'danger'" size="mini" effect="plain">
                                            {{ t === 'Addition' ? '加分' : '扣分' }}
                                        </el-tag>
                                    </div>
                                    <span v-else>—</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="值周分" min-width="90" align="center">
                                <template slot-scope="scope">
                                    <span :class="scoreClass(scope.row.DutyInspectTotalScore, linkScoreType(scope.row))">
                                        {{ formatDecimal(scope.row.DutyInspectTotalScore) }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="DutyInspectRecordId" label="值周记录Id" min-width="150" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="detailVisible = false">关闭</el-button>
                </div>
            </el-dialog>
        </section>
    </section>
</template>

<script>
import util from '../../../../util/date';
import {
    getDormInspectRecords,
    getDormInspectRecordDetail,
    deleteDormInspectRecord,
    exportDormInspectRecords,
    getBuildingsListPage,
} from '../../../api/modules/dormitory';
import { resolveActiveSchoolId, toDeptId, treeNodeDeptId } from '../../../utils/deptCascaderProps';
import DepartmentPane from '../../../components/DepartmentPane';

export default {
    name: 'DormInspectRecord',
    components: { DepartmentPane },
    data() {
        const today = util.formatDate.format(new Date(), 'yyyy-MM-dd');
        const weekStart = util.formatDate.format(util.getStartOfWeek(new Date()), 'yyyy-MM-dd');
        return {
            DepartmentId: 0,
            buildingOptions: [],
            filters: {
                buildingId: null,
                roomCode: '',
                roomId: null,
                inspectorName: '',
                dateRange: [weekStart, today],
            },
            records: [],
            listLoading: false,
            exporting: false,
            page: 1,
            pageSize: 10,
            total: 0,
            detailVisible: false,
            detailLoading: false,
            detail: null,
        };
    },
    methods: {
        scoreClass(val, changeType) {
            const n = Number(val);
            if (val === null || val === undefined || val === '' || Number.isNaN(n)) return '';
            if (n > 0 || (n === 0 && changeType === 'Addition')) return 'add-value';
            if (n < 0 || (n === 0 && changeType === 'Deduction')) return 'deduct-value';
            return '';
        },
        /**
         * 汇总一条检查记录的加分/扣分类型。最后修改：2026-10-13
         * 同一条记录既有加分又有扣分时，两个标签都显示。
         */
        recordChangeTypes(row) {
            if (!row) return [];
            const fromApi = row.ChangeTypes || row.changeTypes;
            if (Array.isArray(fromApi)) return fromApi;
            const items = Array.isArray(row.Items) ? row.Items : [];
            const hasAddition = items.some(it => it && it.ChangeType === 'Addition');
            const hasDeduction = items.some(it => it && it.ChangeType === 'Deduction');
            const types = [];
            if (hasAddition) types.push('Addition');
            if (hasDeduction) types.push('Deduction');
            return types;
        },
        /** 同步值周记录的加分/扣分类型。最后修改：2026-10-13 */
        linkChangeTypes(row) {
            if (!row) return [];
            const types = row.ChangeTypes || row.changeTypes;
            return Array.isArray(types) ? types : [];
        },
        /** 只有一种类型时才用来给 0 分上色，加减同时存在时按分值正负显示。 */
        linkScoreType(row) {
            const types = this.linkChangeTypes(row);
            return types.length === 1 ? types[0] : '';
        },
        formatDecimal(val) {
            if (val === null || val === undefined || val === '') return '';
            const n = Number(val);
            return Number.isNaN(n) ? val : n.toFixed(2);
        },
        /** 关联值周显示三级项名称。最后修改：2026-10-13 */
        formatDutyItemName(row) {
            if (!row) return '不同步';
            const name = row.DutyInspectItemName || row.dutyInspectItemName;
            if (name) return name;
            const itemId = row.DutyInspectItemId || row.dutyInspectItemId;
            return itemId ? '已关联' : '不同步';
        },
        formatDate(val) {
            if (!val) return '';
            return String(val).substring(0, 10);
        },
        formatClasses(row) {
            if (!row) return '';
            if (row.ClassNames) return Array.isArray(row.ClassNames) ? row.ClassNames.join('、') : row.ClassNames;
            if (row.Classes && row.Classes.length) {
                return row.Classes.map(c => c.DepartmentName || c.Name).filter(Boolean).join('、');
            }
            return row.DepartmentNames || '-';
        },
        canDelete(row) {
            if (row.CanDelete === false) return false;
            return true;
        },
        /** 当前学校 Id（字符串）。最后修改：2026-10-18 */
        resolveSchoolId() {
            return resolveActiveSchoolId(this) || toDeptId(this.DepartmentId);
        },
        treeNodeClick(data) {
            const id = treeNodeDeptId(data);
            if (!id) return;
            this.DepartmentId = id;
            this.loadBuildings();
            this.applyRouteQuery();
            this.handleQuery();
        },
        applyRouteQuery() {
            const q = this.$route.query || {};
            if (q.roomId) this.filters.roomId = Number(q.roomId) || q.roomId;
            if (q.roomCode) this.filters.roomCode = q.roomCode;
            if (q.buildingId) this.filters.buildingId = Number(q.buildingId) || q.buildingId;
            if (q.date) this.filters.dateRange = [q.date, q.date];
            if (q.startDate && q.endDate) this.filters.dateRange = [q.startDate, q.endDate];
        },
        loadBuildings() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) return;
            getBuildingsListPage({ page: 1, intPageSize: 500, departmentId: schoolId }).then(res => {
                this.buildingOptions = (res.data && res.data.response && res.data.response.data) || [];
            });
        },
        onBuildingChange() {
            this.filters.roomId = null;
        },
        handleQuery() {
            this.page = 1;
            this.loadRecords(1);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.loadRecords(1);
        },
        buildQueryParams(page) {
            const start = this.filters.dateRange && this.filters.dateRange[0];
            const end = this.filters.dateRange && this.filters.dateRange[1];
            const schoolId = this.resolveSchoolId();
            return {
                schoolId,
                departmentId: schoolId,
                buildingId: this.filters.buildingId || undefined,
                roomId: this.filters.roomId || undefined,
                roomCode: this.filters.roomCode || undefined,
                inspectorName: this.filters.inspectorName || undefined,
                startDate: start,
                endDate: end,
                page: page || this.page,
                intPageSize: this.pageSize,
            };
        },
        loadRecords(page = 1) {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) return;
            this.page = page;
            this.listLoading = true;
            getDormInspectRecords(this.buildQueryParams(page)).then(res => {
                if (res.data && res.data.success) {
                    const resp = res.data.response || {};
                    this.records = resp.data || [];
                    this.total = resp.dataCount || 0;
                } else {
                    this.records = [];
                    this.total = 0;
                    this.$message.error((res.data && res.data.msg) || '加载失败');
                }
            }).finally(() => {
                this.listLoading = false;
            });
        },
        openDetail(row) {
            this.detailVisible = true;
            this.detailLoading = true;
            this.detail = null;
            getDormInspectRecordDetail({ id: row.Id || row.RecordId }).then(res => {
                if (res.data && res.data.success) {
                    this.detail = this.normalizeRecordDetail(res.data.response);
                } else {
                    this.$message.error((res.data && res.data.msg) || '获取明细失败');
                    this.detailVisible = false;
                }
            }).finally(() => {
                this.detailLoading = false;
            });
        },
        /**
         * 明细接口为 { Record, Items, Classes, Links }，页面按扁平字段展示。创建于 2026-09-20
         */
        normalizeRecordDetail(resp) {
            if (!resp) return null;
            const record = resp.Record || resp.record || {};
            const items = resp.Items || resp.items || [];
            const classes = resp.Classes || resp.classes || record.Classes || [];
            const links = resp.Links || resp.links || resp.DutyLinks || [];
            return {
                ...record,
                Items: items,
                Classes: classes,
                DutyLinks: links,
                ClassNames: record.ClassNames || (classes.length
                    ? classes.map(c => c.DepartmentName || c.Name).filter(Boolean).join('、')
                    : ''),
            };
        },
        handleDelete(row) {
            this.$confirm('删除将回滚已同步的值周分，并可能通知班主任撤销。确认删除？', '提示', { type: 'warning' })
                .then(() => {
                    deleteDormInspectRecord({ id: row.Id || row.RecordId }).then(res => {
                        if (res.data && res.data.success) {
                            this.$message.success('删除成功');
                            this.loadRecords(this.page);
                        } else {
                            this.$message.error((res.data && res.data.msg) || '删除失败');
                        }
                    });
                }).catch(() => {});
        },
        async exportExcel() {
            try {
                this.exporting = true;
                const params = this.buildQueryParams(1);
                delete params.page;
                delete params.intPageSize;
                const response = await exportDormInspectRecords(params);
                if (!response.data) {
                    this.$message.error('导出数据为空');
                    return;
                }
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const start = params.startDate || '';
                const end = params.endDate || start;
                link.setAttribute('download', `宿舍检查记录-${start}_${end}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (e) {
                this.$message.error('导出失败');
            } finally {
                this.exporting = false;
            }
        },
    },
    mounted() {
        this.applyRouteQuery();
    },
};
</script>

<style scoped>
.add-value { color: #67c23a; }
.deduct-value { color: #f56c6c; }
.record-info .muted { color: #606266; margin: 0 0 6px 0; }
.record-info .summary { margin: 0; color: #606266; }
.section-title { font-weight: 600; margin-bottom: 8px; color: #303133; }
.type-tags {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}
</style>
